import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { SharedModule } from '../../../ui-components/shared.module';

@Component({
  selector: 'vw-app-menu-item',
  imports: [
    TranslatePipe,
    NgClass,
    SharedModule,
  ],
  templateUrl: './app-menu-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-menu-item.component.scss'
})
export class AppMenuItemComponent {
  @Input() currentScreen;
  @Input() screenName;
  @Input() iconUrl;
  @Input() label;
  @Input() iconTemplate: TemplateRef<any> | null;
  @Input() disabled: boolean = false;
}
